import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class ContentfulService {

 constructor(
   private http: HttpService,
   @Inject(LOCALE_ID) public locale: string
 ) {}

 getEntryIds(landingPageId: string): Observable<any> {
   return this.http.getContentfulEntryIds(landingPageId);
 }
 
 getEntry(sysId: string): Observable<any> {
   return this.http.getContentfulEntry(sysId, this.locale);
 }
}